import React, {useEffect, useState} from 'react';


interface IComponentProps {
  data: any;
  valueKey?: any
  enums: any;
  nameSpace: string;
}
const EnumKeyToText: React.FC<IComponentProps> = (props) => {
  const { nameSpace, enums, data, valueKey } = props
  const [text, setText] = useState('');

  useEffect(() => {
    const list = enums?.[nameSpace] || [];
    list?.forEach?.((item: any) => {
      if (item['key'] === data[valueKey]) {
        setText(item?.value || '-')
      }
    })
  }, [props]);

  return (
    <>
      {text}
    </>
  );
};

export default EnumKeyToText;
